import React, { useEffect, useState } from "react";
import ShopCard from "./ShopCard";

const ShopCardGrid = ({ cards, handleUpdate, handleDelete, selectedIds = [], onToggleSelect, handleManageBilling, handleCancelSubscription, handleStartBilling, handleStartSetup }) => {
  /** Móvil/tablet: solo una tarjeta con el panel de detalle abierto */
  const [openDetailShopId, setOpenDetailShopId] = useState(null);

  useEffect(() => {
    if (openDetailShopId == null || !cards?.length) return;
    const stillThere = cards.some((c) => String(c.id) === String(openDetailShopId));
    if (!stillThere) setOpenDetailShopId(null);
  }, [cards, openDetailShopId]);

    if (!cards || cards.length === 0) {
        return (
          <div className="bg-white rounded-lg shadow border border-gray-200 p-12 text-center">
            <div className="text-gray-400 mb-2">
              <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
            </div>
            <p className="text-gray-500 text-lg font-medium">No hay tiendas disponibles</p>
            <p className="text-gray-400 text-sm mt-1">Crea tu primera tienda para comenzar</p>
          </div>
        );
    }

    return (
      <div className="grid grid-cols-1 items-start gap-4 sm:grid-cols-2 sm:gap-5 lg:grid-cols-3 lg:items-stretch lg:gap-6 xl:grid-cols-4">
       {cards.map((card) => (
          <ShopCard
            key={card.id} 
            id={card.id}
            name={card.name}
            address={card.address}
            city={card.city}
            postalCode={card.postal_code}
            phone={card.phone}
            email={card.email}
            website={card.website}
            taxId={card.tax_id}
            description={card.description}
            venueType={card.venue_type}
            planTier={card.plan_tier}
            activationStatus={card.activation_status}
            subscriptionStatus={card.subscription_status}
            stripeCustomerId={card.stripe_customer_id}
            shop_owners={card.owners}
            shopImage={card.image_path}
            date_created={card.date_created}
            handleUpdate={handleUpdate}
            handleDelete={handleDelete}
            selectedIds={selectedIds}
            onToggleSelect={onToggleSelect}
            handleManageBilling={handleManageBilling}
            handleCancelSubscription={handleCancelSubscription}
            handleStartBilling={handleStartBilling}
            handleStartSetup={handleStartSetup}
            isMobileAccordionOpen={
              openDetailShopId === card.id || String(openDetailShopId) === String(card.id)
            }
            onMobileAccordionToggle={() =>
              setOpenDetailShopId((cur) =>
                cur === card.id || String(cur) === String(card.id) ? null : card.id
              )
            }
          />
        ))}
      </div>
    );
  };
  
  export default ShopCardGrid;
